import { Grid2X2Icon, HomeIcon, NewspaperIcon, PieChartIcon, XIcon } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import sidebarStore from '../stores/sidebarStore';
import Frame from '../uikit/Frame';
import { CommonLink } from './common/CommonLink';

const Sidebar = observer(() => {
    const [isMounted, setIsMounted] = useState(false);

    const location = useLocation();
    const prevLocation = useRef(location);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    /**
     * 라우팅이 바뀌면 사이드바를 닫음
     */
    useEffect(() => {
        if (prevLocation.current !== location) {
            sidebarStore.closeSidebar();
        }
        prevLocation.current = location;
    }, [location]);

    /**
     * 사이드바가 열려있을 때, 윈도우 사이즈가 950px 이 넘으면 닫아줌
     */
    useEffect(() => {
        if (!sidebarStore.isOpen) {
            return;
        }

        const handleResize = () => {
            // css 로 숨김 처리하지만 레이어까지 완전히 닫아주기 위해 추가로 붙여줌
            if (window.innerWidth < 950) {
                sidebarStore.closeSidebar();
            }
        };

        // 초기 체크
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [sidebarStore.isOpen]);

    if (!isMounted) {
        return null;
    }

    return (
        <div className="drawer-side hidden-when-desktop z-(--z-index-sidebar)">
            <label htmlFor="sidebar" aria-label="close sidebar" className="drawer-overlay"></label>
            <div className="bg-base-100 h-full w-50">
                <SidebarContent />
            </div>
        </div>
    );
});

export const SidebarContent = observer(() => {
    const getActiveClassName = ({ isActive }: { isActive: boolean }) => {
        if (isActive) {
            return 'text-base-content font-semibold';
        }

        return 'text-base-content/60';
    };

    return (
        <Frame className="bg-transparent">
            <div className="hidden-when-desktop -mt-4 pr-2 pl-4">
                <div className="flex h-(--navbar-height) items-center justify-between">
                    <CommonLink
                        to={'/'}
                        className="btn btn-ghost btn-square btn-sm"
                        preventScrollReset={false}
                    >
                        <img
                            className="size-5"
                            src={'https://static.haewao.com/images/logo/haewao_circle.svg'}
                            alt="해와오"
                        />
                    </CommonLink>
                    <button
                        className="btn btn-ghost btn-square btn-sm text-base-content/60"
                        onClick={() => {
                            sidebarStore.closeSidebar();
                        }}
                    >
                        <XIcon className="size-6 stroke-1" />
                    </button>
                </div>
            </div>
            <ul className="menu min-h-full w-full gap-1 text-base">
                <li>
                    <CommonLink to="/" className={getActiveClassName} preventScrollReset={false}>
                        <HomeIcon className="size-4 stroke-2 opacity-80" />홈
                    </CommonLink>
                </li>
                <li>
                    <CommonLink
                        to="/news"
                        className={getActiveClassName}
                        preventScrollReset={false}
                    >
                        <NewspaperIcon className="size-4 stroke-2 opacity-80" />
                        뉴스
                    </CommonLink>
                </li>
                {/* <li>
                    <CommonLink
                        to="/challenge"
                        className={getActiveClassName}
                        preventScrollReset={false}
                    >
                        <TrophyIcon className="size-4 stroke-2 opacity-80" />
                        챌린지
                    </CommonLink>
                </li> */}
                <li>
                    <CommonLink
                        to="/portfolio"
                        className={getActiveClassName}
                        preventScrollReset={false}
                    >
                        <PieChartIcon className="size-4 stroke-2 opacity-80" />
                        포트폴리오
                    </CommonLink>
                </li>
                <li>
                    <CommonLink
                        to="/more"
                        className={getActiveClassName}
                        preventScrollReset={false}
                    >
                        <Grid2X2Icon className="size-4 stroke-2 opacity-80" />
                        더보기
                    </CommonLink>
                </li>
            </ul>
        </Frame>
    );
});

export const SidebarButton = observer(
    ({ className, children }: { className?: string; children: React.ReactNode }) => {
        return (
            <label htmlFor="sidebar" className={className}>
                {children}
            </label>
        );
    },
);

export default Sidebar;
